import React from 'react';
import { radioPropTypes } from './RadioPropTypes';
const Radio = ({
  name,
  required,
  classname,
  id,
  value
}) => /*#__PURE__*/React.createElement("input", {
  value: value,
  id: id,
  name: name,
  type: "radio",
  required: required || null,
  className: classname || ''
});
export default Radio;